import createPersistedState from 'use-persisted-state'

const useLocalStorage = (initialState, name) => {
  const useState = createPersistedState(name)
  const [value, setValue] = useState(initialState)

  return {
    value,
    setValue
  }
}

export default useLocalStorage
